import { ErrorMessage } from "../input/input.style";
import UnitLabelledInput, {
  IUnitLabelledInputprops,
} from "../unitLabelledInput";

interface ICustomBPField
  extends Omit<IUnitLabelledInputprops, "name" | "value" | "errorMessage"> {
  firstFieldName: string;
  secondFieldName: string;
  checkBoxFieldName: string;
  firstFieldValue: string;
  secondFieldValue: string;
  checkBoxValue: boolean;
  onChange: (e: any) => void;
  firstFieldErrorMessage: any;
  checkBoxLabel: string;
}

const CustomBPField = (props: ICustomBPField) => {
  const {
    firstFieldName,
    secondFieldName,
    checkBoxFieldName,
    setFieldValue,
    toggleBoxName,
  } = props;
  function onToggleCheck() {
    if (setFieldValue) {
      setFieldValue(firstFieldName, "");
      setFieldValue(secondFieldName, "");
      setFieldValue(checkBoxFieldName, false);
    }
  }
  function onCheckBoxChecked(e: any) {
    props.onChange(e);
    if (setFieldValue) {
      !e.target.checked
        ? setFieldValue(secondFieldName, "")
        : toggleBoxName && setFieldValue(toggleBoxName, false);
    }
  }
  return (
    <>
      <div className="flex flex-col">
        <UnitLabelledInput
          {...props}
          name={props.firstFieldName}
          value={props.firstFieldValue}
          label={props.label}
          unitLabel={props.unitLabel}
          placeholder={"systolic/diastolic"}
          variant="sm"
          onBlur={props.onBlur}
          setFieldValue={props.setFieldValue}
          isImportant={props.isImportant}
          onCheck={onToggleCheck}
          disabled={props.disabled}
        />
        {props.checkBoxValue && (
          <UnitLabelledInput
            name={props.secondFieldName}
            label={""}
            value={props.secondFieldValue}
            unitLabel={props.unitLabel}
            placeholder={"systolic/diastolic"}
            variant="sm"
            onBlur={props.onBlur}
            setFieldValue={props.setFieldValue}
            disabled={props.disabled}
          />
        )}
        {props.firstFieldErrorMessage && (
          <ErrorMessage>{props.firstFieldErrorMessage}</ErrorMessage>
        )}
      </div>
      <div>
        <input
          name={props.checkBoxFieldName}
          id={props.checkBoxFieldName}
          onChange={onCheckBoxChecked}
          value={String(props.checkBoxValue)}
          checked={props.checkBoxValue}
          disabled={props.disabled}
          type={"checkbox"}
        />
        <label htmlFor={props.checkBoxFieldName}>{props.checkBoxLabel}</label>
      </div>
    </>
  );
};

export default CustomBPField;
